export async function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function waitRandom(minMs: number, maxMs: number) {
  return wait(randomIntBetween(minMs, maxMs))
}

export function randomIntBetween(minInclusive: number, maxInclusive: number) {
  return Math.floor(
    Math.random() * (maxInclusive - minInclusive + 1) + minInclusive,
  )
}
